export const convertToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });

export const createMarker = (icon) => {
  const marker = document.createElement('Button');
  marker.classList.add('icon');
  marker.innerHTML = `<img src='./${icon}' alt='test' width="30" height="30"  />`;
  return marker;
};
